import React from "react";

/**
 * Brand logo / wordmark. Uses the transparent FinVault shield mark.
 * Variants:
 *   - "mark"      : shield only (default), good for tight spots
 *   - "wordmark"  : shield + "FinVault" text alongside
 *   - "stacked"   : full graphic with FINVAULT under the shield (uses the full PNG)
 */
export default function Logo({ variant = "wordmark", size = 36, className = "", textClassName = "", testId = "logo" }) {
  if (variant === "stacked") {
    return (
      <img
        src="/finvault-logo.png"
        alt="FinVault"
        height={size}
        className={className}
        data-testid={testId}
        style={{ height: size, width: "auto" }}
      />
    );
  }
  if (variant === "mark") {
    return (
      <img
        src="/finvault-mark.png"
        alt="FinVault"
        className={className}
        data-testid={testId}
        style={{ height: size, width: "auto" }}
      />
    );
  }
  // wordmark
  return (
    <span className={`inline-flex items-center gap-2 ${className}`} data-testid={testId}>
      <img
        src="/finvault-mark.png"
        alt=""
        aria-hidden="true"
        style={{ height: size, width: "auto" }}
      />
      <span className={`font-display font-bold tracking-tight ${textClassName}`} style={{ fontSize: size * 0.55 }}>
        FinVault
      </span>
    </span>
  );
}
